<div class="text-center">
  <mat-icon>lock</mat-icon>
  <h2>No tienes acceso a esta pantalla</h2>
</div>